import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import PerformanceGoalProposalsPage from "@/pages/admin/PerformanceGoalProposalsPage";

export const Route = createFileRoute("/_admin/admin/performance/goal-proposals")({
  head: () => pageHead("Admin · Performance · Goal Proposals", "AKIVA admin · performance · goal proposals portal.", "/admin/performance/goal-proposals", true),
  component: PerformanceGoalProposalsPage,
});
